<app-booking-request-display-tab
  [dataSource]="dataSource"
  [columnsToDisplay]="columnsToDisplay"
  [titleToDisplay]="titleToDisplay"
  [actions]="actions"
  [rowColorRenderer]="rowColorRenderer"
  class="booking_display"
>
</app-booking-request-display-tab>
